import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f39ee11"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "members",
  "element-loading-background": "var(--light-grey-color)"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "members__name" }
const _hoisted_4 = {
  key: 2,
  class: "members__read-more"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "9",
  viewBox: "0 0 10 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.29286 5.00003H0V4.00003H7.29285L4.64641 1.35359L5.35352 0.646484L9.20707 4.50004L5.35352 8.35359L4.64641 7.64648L7.29286 5.00003Z" })
], -1))
const _hoisted_6 = {
  key: 1,
  class: "members-error"
}

import { computed } from 'vue'
import { RvwaMember } from '../model/types/rvwa'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberListRVWA',
  props: {
    members: null
  },
  setup(__props: any) {

const props = __props as {
	members: Array<RvwaMember>
};


const store = useAppStore()
const isLoading = computed(() => store.state.rvwa.isLoading)
const error = computed(() => store.state.rvwa.error)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (!_unref(error))
    ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.members, (member) => {
          return (_openBlock(), _createElementBlock("li", {
            key: member.name
          }, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["members__item", { 'members__item--active': member.id }]),
              to: member.id ? `/organization/${member.id}` : ''
            }, {
              default: _withCtx(() => [
                (member.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `data:image/${member.imageType === 'JPG' ? 'jpeg' : 'png'};base64,${member.image}`,
                      class: "members__img",
                      alt: member.name
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(member.name), 1),
                (member.region)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: `/district/${member.region.district}/region/${member.region.code}`,
                      class: "members__location"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(member.region.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (member.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createTextVNode(" Подробнее "),
                      _hoisted_5
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ]))
        }), 128))
      ])), [
        [_directive_loading, _unref(isLoading)]
      ])
    : (_openBlock(), _createElementBlock("div", _hoisted_6, " Произошла ошибка при загрузке данных: " + _toDisplayString(_unref(error)), 1))
}
}

})